import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-737a9123"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "output" }
const _hoisted_2 = { class: "output__wrapper" }

import ListOutputItem from './ListOutputItem.vue';
import { SettingsStore, useSettingsStore } from '@/store/settings';


export default /*#__PURE__*/_defineComponent({
  __name: 'ListOutput',
  setup(__props) {

const settingsStore: SettingsStore = useSettingsStore();
const { settings } = settingsStore;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(settings), (_, index) => {
        return (_openBlock(), _createBlock(ListOutputItem, {
          index: index,
          key: index,
          title: `List ${index + 1}`
        }, null, 8, ["index", "title"]))
      }), 128))
    ])
  ]))
}
}

})